import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {semanticColor, sizing} from "@khanacademy/wonder-blocks-tokens";
import {Body, LabelSmall} from "@khanacademy/wonder-blocks-typography";

import type {ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions as ActivitySessionsReportRow} from "./__graphql-types__/ActivitySessionsV2Query.ts";
import ActivitySessionsContentIcon from "./activity-sessions-content-icon.tsx";
import isBasicActivitySession from "./is-basic-activity-session.ts";

interface Props {
    row: ActivitySessionsReportRow;
    studentKaid: string;
}

const ActivityNameCell: React.FC<Props> = ({row, studentKaid}) => {
    const isBasicSession = isBasicActivitySession(row);
    const isWritingCoachSession = row.activityKind?.id === "AiGuideWriting";
    const essayTitle = isBasicSession && row.essaySession?.essayTitle;
    const title =
        isWritingCoachSession && essayTitle ? essayTitle : row.title || "";
    const subtitle =
        isWritingCoachSession && essayTitle ? row.title : row.subtitle || "";
    const aiThreadID = isBasicSession && row.aiGuideThread?.id;

    return (
        <View style={styles.activityCell}>
            <View style={styles.activityIconAndTitle}>
                <ActivitySessionsContentIcon activityKind={row.activityKind} />
                {isWritingCoachSession && aiThreadID ? (
                    <Link
                        href={`/profile/${studentKaid}/khanmigo/history/${aiThreadID}`}
                        style={styles.textWithEllipsis}
                        target="_blank"
                    >
                        {title}
                    </Link>
                ) : (
                    <Body style={styles.textWithEllipsis} title={title}>
                        {title}
                    </Body>
                )}
            </View>
            <LabelSmall style={[styles.courseLabel, styles.textWithEllipsis]}>
                {subtitle}
            </LabelSmall>
        </View>
    );
};

const styles = StyleSheet.create({
    activityCell: {
        paddingBlockStart: sizing.size_120,
        paddingBlockEnd: sizing.size_120,
        maxWidth: 280,
        height: 70,
        justifyContent: "center",
    },
    activityIconAndTitle: {
        flexDirection: "row",
        alignItems: "center",
    },
    courseLabel: {
        color: semanticColor.core.foreground.neutral.default,
        marginBlockStart: sizing.size_040,
        marginInlineStart: sizing.size_240,
    },
    textWithEllipsis: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
});

export default ActivityNameCell;
